import styled from 'styled-components'

const BackButtonStyle = styled.div`
	--contMarginBottom: var(--sp5x);

	position: absolute;
	top: var(--infoContPadding);
	left: var(--infoContPadding);
	display: flex;
	align-items: center;
	margin-bottom: var(--contMarginBottom);
	text-transform: capitalize;
	z-index: 2;
	cursor: pointer;

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--contMarginBottom: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--contMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--contMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--contMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--contMarginBottom: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--contMarginBottom: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeSMin}) {
		--contMarginBottom: var(--sp5x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
		--contMarginBottom: var(--sp5x);
	}
`

export default BackButtonStyle
